import Carousel from "./components/Carousel";
Carousel.mount();
